import React from "react";
import { Container, Row, Col, Button, Accordion } from "react-bootstrap";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const NextArrow = ({ onClick }) => (
  <div className="slider-arrow next" onClick={onClick}>
    <FaChevronRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="slider-arrow prev" onClick={onClick}>
    <FaChevronLeft />
  </div>
);

const KushinagarPackage = () => {

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className="package-detail">

      {/* HERO BANNER */}
      <div
        className="package-hero-banner"
        style={{
          backgroundImage:
            "url('/Images/tour/Kushinagar.jpg')",
        }}
      >
        <Container>
          <div className="hero-content">
            <h1>Kushinagar Buddhist Pilgrimage Tour</h1>

            <p className="hero-subtitle">
              2 Nights / 3 Days • Mahaparinirvana Temple Visit
            </p>

            <div className="hero-price">
              Starting From <span>₹14,999</span> / Per Person
            </div>
          </div>
        </Container>
      </div>

      <Container className="package-container">

        {/* SLIDER + FORM */}
        <Row className="mb-4">

          {/* LEFT SLIDER */}
          <Col lg={8}>
            <div className="package-slider">
              <Slider {...sliderSettings}>
                <img src="/Images/tour/Kushinagar.jpg" alt="" />
                <img src="/Images/tour/kushinagar1.webp" alt="" />
                <img src="/Images/tour/kushinagar2.jpeg" alt="" />
              </Slider>
            </div>
          </Col>

          {/* RIGHT ENQUIRY FORM */}
          <Col lg={4}>
            <div className="enquiry-sidebar">
              <h2>₹14,999</h2>
              <p>Per Person</p>

              <Button variant="danger" className="mb-3">
                Book Now
              </Button>

              <form>
                <input type="text" placeholder="Your Name" />
                <input type="text" placeholder="Mobile Number" />
                <input type="date" />
                <input type="number" placeholder="Persons" />
                <textarea placeholder="Message"></textarea>

                <Button variant="dark">Send Enquiry</Button>
              </form>
            </div>
          </Col>
        </Row>

        {/* MAIN CONTENT */}
        <Row>
          <Col lg={8}>

            <div className="package-header">
              <h1>Kushinagar Buddhist Pilgrimage Tour</h1>
              <p>2 Nights / 3 Days • Spiritual Buddhist Circuit</p>
            </div>

            {/* Highlights */}
            <div className="content-box highlight-box">
              <h3>Tour Highlights</h3>

              <Row>
                <Col md={6}>✔ Mahaparinirvana Temple Visit</Col>
                <Col md={6}>✔ Ramabhar Stupa Exploration</Col>
                <Col md={6}>✔ International Buddhist Monasteries</Col>
                <Col md={6}>✔ Peaceful Meditation Experience</Col>
              </Row>
            </div>

            {/* Overview */}
            <div className="content-box">
              <h3>Overview</h3>
              <p>
                Kushinagar is one of the holiest Buddhist pilgrimage
                destinations where Lord Buddha attained Mahaparinirvana.
                This spiritual tour offers visits to sacred temples,
                monasteries, stupas and meditation centers attracting
                pilgrims from around the world.
              </p>
            </div>

            {/* Itinerary */}
            <div className="content-box">
              <h3>Day Wise Itinerary</h3>

              <Accordion defaultActiveKey="0">

                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    Day 1 – Arrival Kushinagar
                  </Accordion.Header>
                  <Accordion.Body>
                    Arrival and transfer to hotel. Visit Mahaparinirvana
                    Temple and enjoy evening meditation.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    Day 2 – Buddhist Site Exploration
                  </Accordion.Header>
                  <Accordion.Body>
                    Visit Ramabhar Stupa, Japanese Temple, Chinese Temple
                    and various International Buddhist Monasteries.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>Day 3 – Departure</Accordion.Header>
                  <Accordion.Body>
                    Breakfast and transfer for onward journey with
                    peaceful spiritual memories.
                  </Accordion.Body>
                </Accordion.Item>

              </Accordion>
            </div>

            {/* Inclusion / Exclusion */}
            <div className="content-box">
              <Row>

                <Col md={6}>
                  <h4>Inclusions</h4>
                  <ul className="inclusion-list">
                    <li>Hotel Accommodation</li>
                    <li>Daily Breakfast</li>
                    <li>Private Transfers</li>
                    <li>Sightseeing as per itinerary</li>
                  </ul>
                </Col>

                <Col md={6}>
                  <h4>Exclusions</h4>
                  <ul className="exclusion-list">
                    <li>Airfare / Train Fare</li>
                    <li>Personal Expenses</li>
                    <li>Guide Charges</li>
                    <li>Entry Tickets</li>
                  </ul>
                </Col>

              </Row>
            </div>

            {/* Gallery */}
            <div className="content-box">
              <h3>Gallery</h3>

              <Row className="gallery">
                <Col md={4}>
                  <img src="/Images/tour/Kushinagar.jpg" alt="" />
                </Col>
                <Col md={4}>
                  <img src="/Images/tour/kushinagar1.webp" alt="" />
                </Col>
                <Col md={4}>
                  <img src="/Images/tour/kushinagar2.jpeg" alt="" />
                </Col>
              </Row>
            </div>

          </Col>
        </Row>

      </Container>
    </div>
  );
};

export default KushinagarPackage;